import { render, staticRenderFns } from "./ForgetLayout.vue?vue&type=template&id=7a870bc0&"
import script from "./ForgetLayout.vue?vue&type=script&lang=js&"
export * from "./ForgetLayout.vue?vue&type=script&lang=js&"
import style0 from "./ForgetLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports